import { render, staticRenderFns } from "./TabBar.vue?vue&type=template&id=2e0acdd9&scoped=true"
import script from "./TabBar.vue?vue&type=script&lang=js"
export * from "./TabBar.vue?vue&type=script&lang=js"
import style0 from "./TabBar.vue?vue&type=style&index=0&id=2e0acdd9&prod&lang=scss"
import style1 from "./TabBar.vue?vue&type=style&index=1&id=2e0acdd9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0acdd9",
  null
  
)

export default component.exports